import { Services } from '@sigma-frontend-libs/commons'
import { PAYMENTS_METHODS } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, labelModes } from '@/utils'

import filterDate from '@/components/filter/date'
import selectorOwner from '@/components/selector/owner'
import paymentsMethod from '@/components/services/payments/method'

function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

function renderStatusSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.status,
        label: this.getTranslate(`${Services.payments}.labels.status`),
        items: this.statusItems,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.status = event
        }
      }
    }
  )
}

function renderMethodSelect(h) {
  return h(
    paymentsMethod,
    {
      props: {
        value: this.proxy.method,
        items: PAYMENTS_METHODS,
        dense: true,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.method = event
        }
      }
    }
  )
}

function renderDateTimeFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt,
        preset: this.proxy.createdAtPreset,
        presets: true
      },
      on: {
        input: event => {
          if (event) {
            this.proxy.createdAtPreset = undefined
          }

          this.proxy.createdAt = event
        },
        preset: event => {
          this.proxy.createdAtPreset = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.payments}-filter`]: true,
        [`${Services.payments}-filter--admin`]: this.canGetUsersAsResellerUp
      }
    },
    [
      renderSelectorOwner.call(this, h),
      renderStatusSelect.call(this, h),
      renderMethodSelect.call(this, h),
      renderDateTimeFilter.call(this, h)
    ]
  )
}
